var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickupTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964",
    transform: "translate(-920 -304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9573",
    "data-name": "Rectangle 9573",
    width: 41,
    height: 41,
    rx: 20.5,
    transform: "translate(920 304)",
    fill: "#ff8226"
  }), /*#__PURE__*/React.createElement("g", {
    id: "date-time-svgrepo-com",
    transform: "translate(910 295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5251",
    "data-name": "Path 5251",
    d: "M37.056,21.807H35.55v-.6a1.2,1.2,0,0,0-2.409,0v.6h-5.42v-.6a1.2,1.2,0,0,0-2.409,0v.6H23.807A1.812,1.812,0,0,0,22,23.613v.6a.6.6,0,0,0,.6.6H38.26a.6.6,0,0,0,.6-.6v-.6A1.812,1.812,0,0,0,37.056,21.807Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5252",
    "data-name": "Path 5252",
    d: "M38.26,42H22.6a.6.6,0,0,0-.6.6v9.033a1.812,1.812,0,0,0,1.807,1.807H37.056a1.812,1.812,0,0,0,1.807-1.807V42.6A.6.6,0,0,0,38.26,42ZM30.431,52.208a4.487,4.487,0,1,1,4.487-4.487A4.5,4.5,0,0,1,30.431,52.208Z",
    transform: "translate(0 -15.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5253",
    "data-name": "Path 5253",
    d: "M49.4,55.228V53.3a.3.3,0,0,0-.3-.3h-.3a.3.3,0,0,0-.3.3v2.108a.349.349,0,0,0,.12.3l1.445,1.445a.291.291,0,0,0,.422,0l.211-.211a.291.291,0,0,0,0-.422Z",
    transform: "translate(-18.521 -23.063)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupTime);
export default __webpack_public_path__ + "static/media/pickup_time.2fe5112c3f143fe1ccf5a9fe09f2f61d.svg";
export { ForwardRef as ReactComponent };